import httpClient from './httpClient'

export default {
  PurchaseOrderNumber: {
    GetBillingPONumber() {
      return httpClient.post('/Dealer/GetBillingPONumber')
    },
    AddBillingPONumber(payload) {
      return httpClient.post('/Dealer/AddBillingPONumber', payload)
    },
  },
}
